const report = (msg, tcdcmpid) => {
	if (window.newrelic) {
		window.newrelic.addPageAction('callsource', {
			tcdcmpid,
			callsourceStatus: msg
		});
	}
};

export const initAiIdExchange = async () => {
	const tcdcmpidFromSession = sessionStorage.getItem('tcdcmpid');

	if (tcdcmpidFromSession) {
		report('tcdcmpid found in session storage', tcdcmpidFromSession);
	}

	const tcdcmpid =
		new URLSearchParams(window.location.search).get('tcdcmpid') ||
		tcdcmpidFromSession;

	if (tcdcmpid && window.aiIdExchange) {
		try {
			const { callsourceSessionId } = await window.aiIdExchange(tcdcmpid);
			if (!callsourceSessionId) {
				throw new Error('callsourceSessionId is undefined');
			} else {
				report('aiIdExchange success', tcdcmpid);
			}
			window.coxAutoDataLayer.push({
				user: {
					sessionizedCallTrackingId: callsourceSessionId
				}
			});
		} catch (e) {
			window?.DDC?.log('error', 'aiIdExchange failed');
			report('aiIdExchange failed', tcdcmpid);
		}
	}
};
